<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <g transform="translate(-22 -146)">
      <path class="a" d="M0,0V16" transform="translate(31 147)"/>
      <path class="a" d="M0,0H16" transform="translate(23 155)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'NewLeadIcon'
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #FFFFFF;
  stroke-linecap: round;
  stroke-width: 2px;
}
</style>
